var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg3Dcube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.92 2.26375L19.43 5.77375C20.19 6.18375 20.19 7.35375 19.43 7.76375L12.92 11.2738C12.34 11.5838 11.66 11.5838 11.08 11.2738L4.57 7.76375C3.81 7.35375 3.81 6.18375 4.57 5.77375L11.08 2.26375C11.66 1.95375 12.34 1.95375 12.92 2.26375Z",
    stroke: "#000000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.61 10.1277L9.66 13.1577C10.41 13.5377 10.89 14.3077 10.89 15.1477V20.8677C10.89 21.6977 10.02 22.2277 9.28 21.8577L3.23 18.8277C2.48 18.4477 2 17.6777 2 16.8377V11.1177C2 10.2877 2.87 9.75773 3.61 10.1277Z",
    stroke: "#000000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3899 10.1277L14.3399 13.1577C13.5899 13.5377 13.1099 14.3077 13.1099 15.1477V20.8677C13.1099 21.6977 13.9799 22.2277 14.7199 21.8577L20.7699 18.8277C21.5199 18.4477 21.9999 17.6777 21.9999 16.8377V11.1177C21.9999 10.2877 21.1299 9.75773 20.3899 10.1277Z",
    stroke: "#000000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Dcube);
export default __webpack_public_path__ + "static/media/3dcube.54b9946ef76011ae617f5f4b89076e4e.svg";
export { ForwardRef as ReactComponent };